import { SearchIcon as UiSearchIcon, colors, spacing } from '@chegg-ui/theme'
import styled from 'styled-components'
import { AspiraRegular, FontSize16 } from '@chegg-wt/core/theme/sunkist/fonts'
import { values } from '@chegg-wt/core/theme/sunkist/spacing'

export const SearchBarWrapper = styled.div`
  padding: ${values.xsmall};
  border-bottom: 1px solid ${({ theme }) => theme.Colors.forInterface.interfaceColor13};
  position: relative;
`

export const SearchBar = styled.input`
  ${AspiraRegular};
  ${FontSize16};
  border: 1px solid ${({ theme }) => theme.Colors.forInterface.interfaceColor13};
  border-radius: 2px;
  padding-left: 35px;
  line-height: 18px;
  padding: 10px 0px 8px 35px;
  width: 100%;
  box-sizing: border-box;
  vertical-align: middle;
  &:focus {
    outline: none !important;
    border: 2px solid ${({ theme }) => theme.Colors.primaryColor};
  }
`

export const SearchIcon = styled(UiSearchIcon).attrs({
  size: 'medium',
  color: colors.grey,
  'aria-hidden': true,
})`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: ${spacing.px12};
`
